module.exports = __webpack_public_path__ + "img/logo.fcf3e18a.png";